import formatRupiah from "../../utils/FormatRupiah";
import formatTanggal from "../../utils/FormatTanggal";
import formatTime from "../../utils/FormatTime";


const columns = [
  {
    title: "Order Date",
    dataIndex: "created_date",
    key: "created_date",
    render: (text) => <p>{formatTanggal(text)}</p>,
  },
   {
    title: "Order Time",
    dataIndex: "created_date",
    key: "created_date",
    render: (text) => <p>{formatTime(text)}</p>,
  },
  // created_date
  // {
  //   title: "No",
  //   key: "no",
  //   render: (text, record, index) =>
  //     (pagination.current - 1) * pagination.pageSize + index + 1,
  //   width: 50,
  //   align: "center",
  // },
  // {
  //   title: "Application ID",
  //   dataIndex: "application_id",
  //   key: "application_id",
  //   // width: 200,
  //   // render: (text) => <a>{text}</a>,
  // },
  {
    title: "NAMA",
    dataIndex: "nama",
    key: "nama",
    // render: (text) => <a>{text}</a>,
  },
  {
    title: "NIK",
    dataIndex: "nik",
    key: "nik",
  },
  // {
  //   title: "ALAMAT",
  //   dataIndex: "alamat",
  //   key: "alamat",
  // },
   {
    title: "Nama CMO",
    dataIndex: "created_by",
    key: "created_by",
  },
  // {
  //   title: "MARITAL STATUS",
  //   dataIndex: "maritalstatus",
  //   key: "maritalstatus",
  //   render: (text) => (
  //     <a
  //       // href="https://www.google.com"
  //       style={{ color: "blue", textDecoration: "underline" }}
  //     >
  //       Menikah
  //     </a>
  //   ),
  // },

  {
  title: "SLIK",
  dataIndex: "uri_slik",
  key: "uri_slik",
  render: (text) => {
    if (!text) return "-"; // jika null, undefined, atau kosong, tampilkan '-'

    return (
      <a
        href={text}
        target="_blank"
        rel="noreferrer"
        style={{ color: "blue", textDecoration: "underline" }}
      >
        Download
      </a>
    );
  },
}
,
  {
  title: "SUMMARY SLIK",
  dataIndex: "summary_slik",
  key: "summary_slik",
  render: (text) => {
    if (!text) return "-"; // jika null, undefined, atau kosong, tampilkan '-'

    return (
      <a
        href={text}
        target="_blank"
        rel="noreferrer"
        style={{ color: "blue", textDecoration: "underline" }}
      >
        Download
      </a>
    );
  },
},
{
  title: "STATUS",
  dataIndex: "is_survey",
  key: "is_survey",
  render: (text) => {
    let status = "Pre-Check";
    if (text === 1) status = "Survey In Progress";
    else if (text === 0) status = "Rejected";

    return <p className="capitalize font-semibold">{status}</p>;
  },
}
  // {
  //   title: "DEBET",
  //   dataIndex: "debet",
  //   key: "debet",
  //   render: (text) => <p>{formatRupiah(text)}</p>,
  // },
  // {
  //   title: "KREDIT",
  //   dataIndex: "kredit",
  //   key: "kredit",
  //   render: (text) => <p>{formatRupiah(text)}</p>,
  // },
  // {
  //   title: "SALDO",
  //   dataIndex: "saldo",
  //   key: "saldo",
  //   render: (text) => <p>{formatRupiah(text)}</p>,
  // },
  // {
  //   title: "Amount",
  //   dataIndex: "amount",
  //   key: "amount",
  //   render: (text) => <p>{formatRupiah(text)}</p>,
  // },
];

// const formValidation = [
//   [
//     {
//       title: "No. Akun",
//       key: "noAcc",
//       placeholder: "Masukan No. Akun",
//       type: "text",
//       required: true,
//       validationText: "nomor akun harus diisi!",
//     },
//     {
//       title: "Nama Akun",
//       key: "nameAcc",
//       placeholder: "Masukan Nama Akun",
//       type: "text",
//       required: true,
//       validationText: "nama akun harus diisi!",
//     },
//   ],
//   {
//     title: "Tanggal Masuk",
//     key: "tgl",
//     placeholder: "Masukan tanggal masuk Anggota",
//     type: "dateTime",
//     required: true,
//     validationText: "tanggal masuk harus diisi!",
//   },
//   {
//     title: "Keterangan",
//     key: "keterangan",
//     placeholder: "Masukan Keterangan",
//     type: "textarea",
//     required: true,
//     validationText: "alamat harus diisi!",
//   },
//   [
//     {
//       title: "Debet",
//       key: "debet",
//       placeholder: "Masukan Debet",
//       type: "number",
//       required: true,
//       validationText: "Debet harus diisi!",
//     },
//     {
//       title: "Kredit",
//       key: "kredit",
//       placeholder: "Masukan Kredit",
//       type: "number",
//       required: true,
//       validationText: "Kredit harus diisi!",
//     },
//     {
//       title: "Saldo",
//       key: "saldo",
//       placeholder: "Masukan Saldo",
//       type: "number",
//       required: true,
//       validationText: "Saldo harus diisi!",
//     },
//   ],
// ];

export { columns };
